import { ProductListPerPage } from '../types';

export const LIST_PER_PAGES: ProductListPerPage[] = [
  {
    type: 'search',
    count: 12,
  },
  {
    type: 'categories',
    count: 99,
  },
  {
    type: 'collections',
    count: 99,
  },
];

export const LIST_PER_PAGES_M: ProductListPerPage[] = [
  {
    type: 'search',
    count: 10,
  },
  {
    type: 'categories',
    count: 20,
  },
  {
    type: 'collections',
    count: 20,
  },
];
